import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import React, { useRef, useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import styled from "styled-components";

const responsive = {
  all: {
    breakpoint: { max: 999999999999, min: 0 },
    items: 1
  }
};

const PageText = styled.h3`
  color: #888;
`;

const BookViewer = ({ username, imgUrls, page }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [hasMoved, setHasMoved] = useState(false);
  const [rtlValue, setRtlValue] = useState(false);
  const carouselRef = useRef(null);
  const location = useLocation();
  const handleGoToSlide = (index) => {
    if (carouselRef.current) {
      carouselRef.current.goToSlide(index);
    }
  };

  useEffect(() => {
    setTimeout(() => handleGoToSlide(parseInt(page, 10) - 1), 500);
  }, []);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (carouselRef.current) {
        if (!hasMoved) {
          if (event.key === 'ArrowLeft') {
            setRtlValue(true);
            setHasMoved(true);
            carouselRef.current.next();
          } else if (event.key === 'ArrowRight') {
            setHasMoved(true);
            carouselRef.current.next();
          }
        } else {
          if (event.key === 'ArrowLeft') {
            if (rtlValue) {
              carouselRef.current.next();
            } else {
              carouselRef.current.previous();
            }
          } else if (event.key === 'ArrowRight') {
            if (rtlValue) {
              carouselRef.current.previous();
            } else {
              carouselRef.current.next();
            }
          }
        }
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [hasMoved]);
  let imageUrlsAccessible = imgUrls;
  if (username === null) {
    imageUrlsAccessible = imageUrlsAccessible.slice(0, 10);
  }

  let data = imageUrlsAccessible.map((src, index) => (
    <div key={index}>
      <img
        src={src}
        alt={`Page ${index + 1}`}
        style={{ width: '100%', height: 'auto' }}
      />
    </div>
  ))

  if (username === null) {
    data.push(<div>Log in to view more</div>)
  }

  return (
    <div tabIndex="0">
      <PageText>Page {currentPage}</PageText>
      <Carousel
        ref={carouselRef}
        responsive={responsive}
        arrows
        swipeable={false}
        draggable={false}
        showDots={false}
        infinite={false}
        customTransition="none"
        keyBoardControl={true}
        containerClass="carousel-container"
        itemClass="carousel-item-padding-40-px"
        rtl={rtlValue}
        removeArrowOnDeviceType={["tablet", "mobile"]}
        beforeChange={() => window.scrollTo(0, 0)}
        afterChange={() => {
          const newPage = carouselRef.current.state.currentSlide + 1;
          setCurrentPage(newPage);
          const pathPieces = location.pathname.split("/");
          let newPath = pathPieces[0] + "/" + pathPieces[1] + "/" + pathPieces[2] + "/"
          window.history.replaceState({}, "", `${newPath}${newPage}`);
        }}
      >
        {data}
      </Carousel>
    </div>);
};

export default BookViewer;